import { useSearchParams } from "react-router-dom"
import { useAppDependencies } from "../../context/AppContext"
import LandingPage from "../search/LandingPage"
import OldUrlRedirect from "./OldUrlRedirect"
import PlanModal from "../premium/PlanModal"
import LoginModal from "../login/LoginModal"

export default function HomePageWithRedirect() {
    const [searchParams] = useSearchParams()
    const path = searchParams.get('path')
    const deps = useAppDependencies()

    if (path) {
        return <OldUrlRedirect />
    }

    return (
        <>
            <LandingPage
                stateHandler={deps.stateHandler}
                apiHandler={deps.apiHandler}
                errorHandler={deps.errorHandler}
                loader={deps.loader}
                loginHelper={deps.loginHelper}
                agentFinderUrl={deps.config.getAgentFinderUrl()}
            />
            <PlanModal stateHandler={deps.stateHandler} apiHandler={deps.apiHandler} />
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </>
    )
}
